import getFlagValue from '../utils/getFlagValue';
import { FLAG_ENUM } from '../utils/getFlagValue';

export const emarsysLogout = async () => {
  const isFlagEmarsys = getFlagValue(FLAG_ENUM.EMARSYS);
  const isFlagEmarsysWebPush = getFlagValue(FLAG_ENUM.EMARSYS_WEB_PUSH);
  if (!isFlagEmarsys || !isFlagEmarsysWebPush || typeof WebEmarsysSdk !== 'object') return;
  try {
    await WebEmarsysSdk.logout();
  } catch (error) {
    // do nothing
  }
};

export const emarsysFirstTimePush = () => {
  const isFlagEmarsys = getFlagValue(FLAG_ENUM.EMARSYS);
  const isFlagEmarsysWebPush = getFlagValue(FLAG_ENUM.EMARSYS_WEB_PUSH);
  if (!isFlagEmarsys || !isFlagEmarsysWebPush || typeof WebEmarsysSdk !== 'object') return;
  try {
    WebEmarsysSdk.push(() => {});
  } catch {
    // do nothing
  }
};

export const emarsysReload = () => {
  const isFlagEmarsys = getFlagValue(FLAG_ENUM.EMARSYS);
  if (!isFlagEmarsys) return;
  try {
    ScarabUtil.loadedModules.emarsys_webpersonalization.instance.reload();
  } catch {
    // do nothing
  }
};
